import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from '../../mydatafeed/datafeed_price_feed';

function getLanguageFromURL() {
    const regex = new RegExp('[\\?&]lang=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

let disabledFeatures = ['use_localstorage_for_settings', 'header_saveload'];

const supported_resolutions = ['1', '5', '30', '1H']

export const TVChartContainer = () => {
    const [isFullscreen, setIsFullscreen] = useState(window.innerWidth < 508);
    const chartContainerRef = useRef();

    const defaultProps = {
        symbol: 'USDCLP',
        interval: '1',
        datafeedUrl: 'https://demo_feed.tradingview.com',
        libraryPath: '/charting_library/',
        chartsStorageUrl: 'https://saveload.tradingview.com',
        chartsStorageApiVersion: '1.1',
        clientId: 'https://www.qrtsolutions.com',
        fullscreen: isFullscreen,
        autosize: false,
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 500) {
                setIsFullscreen(true);
            } else {
                setIsFullscreen(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        const widgetOptions = {
            symbol: defaultProps.symbol,
            datafeed: Datafeed,
            interval: defaultProps.interval,
            container: chartContainerRef.current,
            library_path: defaultProps.libraryPath,
            theme: "dark",
            style: "1",
            timezone: "America/Santiago",
            locale: getLanguageFromURL() || 'en',
            disabled_features: disabledFeatures,
            enabled_features: ['study_templates'],
            charts_storage_url: defaultProps.chartsStorageUrl,
            charts_storage_api_version: defaultProps.chartsStorageApiVersion,
            client_id: defaultProps.clientId,
            user_id: defaultProps.userId,
            fullscreen: defaultProps.fullscreen,
            autosize: defaultProps.autosize,
            height: '85%',
            width: '95%',
            supported_resolutions: supported_resolutions,
            compare: {
                symbols: [
                    {
                        symbol: "DXY",
                        title: "Dólar Index"
                    },
                ]
            }
        };

        const tvWidget = new widget(widgetOptions);

        tvWidget.onChartReady(() => {
            console.log('Price Feed Chart Ready');
        });

        return () => {
            window.removeEventListener('resize', handleResize);
            if (tvWidget !== null) {
                tvWidget.remove();
            }
        };
    }, []);

    return (
        <div ref={chartContainerRef} className={'TVChartContainer'} />
    );

}
